import normalize from "json-api-normalizer";
import store from "@/store/index";
import { camelizeKeys } from "humps";
import _ from "lodash";

import BaseService from "./BaseService";

function normalizeDeep(data) {
  const camelData = data;

  if (_.has(camelData, "patientQueues")) {
    // normalize doesn't traverse deep enough when camelizing keys, so we have to do it manually
    _.forEach(Object.keys(camelData.patientQueues), key => {
      camelData.patientQueues[key].attributes = camelizeKeys(
        camelData.patientQueues[key].attributes
      );
    });
  }

  return camelData;
}

export default {
  load(params) {
    let query = `sort=${params.sortDir}${params.sorted}&filter=status=${
      params.status
    },interview=${params.interview}`;
    query += `&search=${params.search}&page[number]=${
      params.pageNumber
    }&location=${params.location}`;
    return BaseService.get(`patient_queue?${query}`)
      .then(response => {
        const data = normalize(response.data);
        store.dispatch("patientQueue/set", {
          queue: normalizeDeep(data),
          links: response.data.links
        });
      })
      .catch(errors => Promise.reject(errors));
  },

  loadPatient(patientId) {
    return BaseService.get(`patient_queue/${patientId}`)
      .then(response => {
        const data = normalize(response.data);
        store.dispatch("patientQueue/add", {
          queue: normalizeDeep(data),
          links: response.data.links
        });
      })
      .catch(errors => Promise.reject(errors));
  },

  getCounts(params = {}) {
    let query = "";
    if (params.location && params.location != "") {
      query = `?location=${params.location}`;
    }

    return BaseService.get(`patient_queue/counts${query}`)
      .then(response => {
        store.dispatch("patientQueue/setCounts", response.data);
      })
      .catch(errors => Promise.reject(errors));
  },

  getInterview(patientId) {
    return BaseService.get(`patient_queue/${patientId}/interview`)
      .then(response => {
        store.dispatch("patientQueue/setInterview", normalize(response.data));
      })
      .catch(errors => Promise.reject(errors));
  },

  update(data) {
    return BaseService.patch("patient-queues", `patient_queue/${data.id}`, data)
      .then(response => {
        store.dispatch("patientQueue/updatePatient", normalize(response.data));
      })
      .catch(errors => Promise.reject(errors));
  },

  createVisit(data) {
    return BaseService.post(
      "patient-queues",
      `patient_queue/${data.id}/create-visit`,
      data
    )
      .then(() => Promise.resolve())
      .catch(errors => Promise.reject(errors));
  }
};
